import React, { Fragment } from "react";
import "components/Spotlight/Spotlight_Common.css";
import CollapseComponent from "components/Spotlight/CollapseComponent";

class CompletedProjects extends React.Component {
  render() {
    return (
      <Fragment>
        <CollapseComponent
          title={"Completed Projects"}
        />{" "}
      </Fragment>
    );
  }
}

export default CompletedProjects;
